// scrolling directive / functionality
import VueScrollTo from 'vue-scrollto';
function scrollToElement(scrollTarget, duration = 350) {
  VueScrollTo.scrollTo(scrollTarget, duration);
}
export default scrollToElement;
